export const messages = {
  en: {
    adminRoomDetail: {
      title: 'Room Details',
      back: 'Back',
      owner: 'Owner',
      member: 'Family Member',
      ownerRoom: 'Owner Room',
      ownerCar: 'Owner Car',
      contract: 'Contract',
      roomFee: 'Room Fee',
      carFee: 'Car Fee',
      paymentHistory: 'Payment History',
      receipt: 'Receipt',
      repair: 'Repair',
      complaint: 'Complaint',
      meterReading: 'Meter Reading',
      historyOwner: 'History Owner'
    },
    adminRoomDetailInfo: {
      roomCode: 'Room Code:',
      floor: 'Floor:',
      roomArea: 'Room Area:',
      roomType: 'Room Type:',
      roomStatus: 'Room Status:',
      indoorArea: 'Indoor Area:',
      rent: 'Rent:',
      validity: 'Validity:',
      ownerName: 'Owner Name:',
      contact: 'Contact:',
      remark: 'Remark:',
      communityName: 'Community Name:'
    },
    aRoomDetailMember: {
      placeholderName: 'Please enter member name',
      face: 'Face',
      name: 'Name',
      sex: 'Gender',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact',
      address: 'Address'
    },
    aRoomDetailCar: {
      placeholderCarNum: 'Please enter license plate number',
      carNum: 'License Plate',
      leaseType: 'Plate Type',
      tempCar: 'Temporary Car',
      carType: 'Vehicle Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      released: 'Released',
      validity: 'Validity'
    },
    aRoomDetailContract: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      operator: 'Operator',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      state: 'Status'
    },
    aRoomDetailCarFee: {
      selectCar: 'Select Car',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      amount: 'Amount',
      createTime: 'Create Time',
      timeRange: 'Time Range',
      description: 'Description',
      state: 'Status',
      operation: 'Operation',
      preDegrees: 'Previous Degrees',
      curDegrees: 'Current Degrees',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional Fee',
      algorithm: 'Algorithm',
      usage: 'Usage',
      fixedFee: 'Fixed Fee',
      note1: 'Note: The end time "-" means the charging time has not arrived or the charging has ended',
      note2: 'Note: The amount -1 generally means an error in the fee formula setting, please check',
      totalArrears: 'Total Arrears',
      parkingLot: ' Parking Lot ',
      parkingSpace: ' Parking Space',
      owner: 'Owner',
      phone: 'Phone',
      noParkingSpace: 'No parking space'
    },
    aRoomDetailRepair: {
      repairId: 'Work Order Code',
      location: 'Location',
      repairType: 'Repair Type',
      repairPerson: 'Repair Person',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      state: 'Status',
      taskProcessing: 'Task Processing',
      detail: 'Detail'
    },
    aRoomDetailComplaint: {
      type: 'Type',
      room: 'Room',
      contact: 'Contact',
      phone: 'Phone',
      status: 'Status',
      handler: 'Handler',
      handlerPhone: 'Handler Phone',
      createTime: 'Create Time',
      actions: 'Actions',
      detail: 'Detail',
      flowChart: 'Flow Chart',
      none: 'None'
    },
    aRoomDetailHisOwner: {
      ownerName: 'Owner Name',
      ownerPhone: 'Owner Phone',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive'
    }
  },
  zh: {
    adminRoomDetail: {
      title: '房屋详情',
      back: '返回',
      owner: '业主',
      member: '家庭成员',
      ownerRoom: '业主房屋',
      ownerCar: '业主车辆',
      contract: '合同',
      roomFee: '房屋费用',
      carFee: '车辆费用',
      paymentHistory: '缴费历史',
      receipt: '收据',
      repair: '报修',
      complaint: '投诉',
      meterReading: '抄表记录',
      historyOwner: '历史业主'
    },
    adminRoomDetailInfo: {
      roomCode: '房屋编号：',
      floor: '楼层：',
      roomArea: '房屋面积：',
      roomType: '房屋类型：',
      roomStatus: '房屋状态：',
      indoorArea: '室内面积：',
      rent: '租金：',
      validity: '有效期：',
      ownerName: '业主名称：',
      contact: '联系电话：',
      remark: '备注：',
      communityName: '小区名称：'
    },
    aRoomDetailMember: {
      placeholderName: '请填写成员名称',
      face: '人脸',
      name: '名称',
      sex: '性别',
      personRole: '人员角色',
      idCard: '身份证',
      contact: '联系方式',
      address: '地址'
    },
    aRoomDetailCar: {
      placeholderCarNum: '请填写车牌号',
      carNum: '车牌号',
      leaseType: '车牌类型',
      tempCar: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      released: '车位已释放',
      validity: '有效期'
    },
    aRoomDetailContract: {
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      operator: '经办人',
      amount: '合同金额(元)',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '起草时间',
      state: '状态'
    },
    aRoomDetailCarFee: {
      selectCar: '选择车辆',
      feeItem: '费用项目',
      feeFlag: '费用标识',
      feeType: '费用类型',
      amount: '应收金额(元)',
      createTime: '建账时间',
      timeRange: '应收时间段',
      description: '说明',
      state: '状态',
      operation: '操作',
      preDegrees: '上期度数',
      curDegrees: '本期度数',
      unitPrice: '单价',
      additionalFee: '附加费',
      algorithm: '算法',
      usage: '用量',
      fixedFee: '固定费',
      note1: '注意： 应收结束时间 "-" 表示未到应收时间 或 收费已结束',
      note2: '注意： 应收金额(元) 为-1 一般为费用项公式设置出错请检查',
      totalArrears: '欠费小计',
      parkingLot: '停车场',
      parkingSpace: '停车位',
      owner: '业主',
      phone: '电话',
      noParkingSpace: '没有车位'
    },
    aRoomDetailRepair: {
      repairId: '工单编码',
      location: '位置',
      repairType: '报修类型',
      repairPerson: '报修人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      state: '状态',
      taskProcessing: '定时任务处理',
      detail: '详情'
    },
    aRoomDetailComplaint: {
      type: '类型',
      room: '房屋',
      contact: '联系人',
      phone: '联系电话',
      status: '状态',
      handler: '处理人',
      handlerPhone: '处理人电话',
      createTime: '创建时间',
      actions: '操作',
      detail: '详情',
      flowChart: '流程图',
      none: '无'
    },
    aRoomDetailHisOwner: {
      ownerName: '业主名称',
      ownerPhone: '业主电话',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      status: '状态',
      active: '在用',
      inactive: '失效'
    }
  }
}
